module.exports = __webpack_public_path__ + "img/Team-Wilde-Pracht-1160.9abeaced.jpg";